import React from 'react';
import SharedModal, { SharedModalSize } from './SharedModal';
import './SharedModal.css';

export interface FormModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: () => void | Promise<void>;
  title: string;
  children?: React.ReactNode;
  submitLabel?: string;
  cancelLabel?: string;
  loading?: boolean;
  size?: SharedModalSize;
  /** Disable submit button when true (e.g. form validation) */
  submitDisabled?: boolean;
}

const FormModal: React.FC<FormModalProps> = ({
  open,
  onClose,
  onSubmit,
  title,
  children,
  submitLabel = 'Save',
  cancelLabel = 'Cancel',
  loading = false,
  size = 'md',
  submitDisabled = false,
}) => {
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await onSubmit();
  };

  const footer = (
    <div className="shared-modal__footer">
      <button
        type="button"
        className="shared-modal__btn shared-modal__btn--secondary"
        onClick={onClose}
        disabled={loading}
      >
        {cancelLabel}
      </button>
      <button
        type="button"
        className="shared-modal__btn shared-modal__btn--primary"
        onClick={handleSubmit}
        disabled={loading || submitDisabled}
      >
        {loading ? 'Please wait...' : submitLabel}
      </button>
    </div>
  );

  return (
    <SharedModal
      open={open}
      onClose={onClose}
      title={title}
      size={size}
      footer={footer}
      showCloseButton={true}
      closeOnOverlayClick={!loading}
    >
      {children}
    </SharedModal>
  );
};

export default FormModal;
